import { isEqual, isUndefined } from 'lodash-es';

import { ConfiguratorDesignArtOption, ConfiguratorDesignColorsOption, ConfiguratorDesignThemeOption } from '../types';

export function reorderThemes(
  themeOption: ConfiguratorDesignThemeOption | undefined,
  currentOptions: ConfiguratorDesignThemeOption[],
): ConfiguratorDesignThemeOption[] {
  if (!isUndefined(themeOption)) {
    const others = currentOptions.filter((theme) => theme.id !== themeOption.id);

    return [themeOption, ...others];
  }

  return currentOptions;
}

export function reorderColors(
  colorOption: ConfiguratorDesignColorsOption | undefined,
  currentOptions: ConfiguratorDesignColorsOption[],
): ConfiguratorDesignColorsOption[] {
  if (!isUndefined(colorOption)) {
    const others = currentOptions.filter((color) => color.id !== colorOption.id);

    return [colorOption, ...others];
  }

  return currentOptions;
}

export function reorderArtStyle(
  artStyleOption: ConfiguratorDesignArtOption | undefined,
  currentOptions: ConfiguratorDesignArtOption[],
): ConfiguratorDesignArtOption[] {
  if (!isUndefined(artStyleOption)) {
    const others = currentOptions.filter((artStyle) => artStyle.id !== artStyleOption.id);

    return [artStyleOption, ...others];
  }

  return currentOptions;
}

export function areArtOptionsEqual(
  prev: ConfiguratorDesignArtOption[] = [],
  next: ConfiguratorDesignArtOption[] = [],
): boolean {
  if (prev.length !== next.length) {
    return false;
  }

  const prevSorted = prev.toSorted((a, b) => a.id - b.id);
  const nextSorted = next.toSorted((a, b) => a.id - b.id);

  return isEqual(prevSorted, nextSorted);
}
